import styled from 'styled-components';
import { Flex, Box } from '@rebass/grid';
import { ResponsiveImg } from '../../components';
import { colors } from '../../styles';

export const LoginWrapper = styled(Flex)`
  background-color: #fff;
  font-size: 12px;
  input[type='checkbox'] {
    position: relative;
    top: 3px;
  }
  button {
    font-size: 12px;
  }
  a {
    text-decoration: none;
  }

  h6 {
    font-weight: 500;
    line-height: 1.1;
    margin-top: 10px;
    margin-bottom: 25px;
    font-size: 14px;
    &.login-header {
      margin-top: 30px;
    }
  }
  label {
    cursor: pointer;
  }
`;

export const LoginPanelBox = styled(Box)`
  width: 100%;
`;

export const LoginPageStyle = styled('div')`
  width: 100%;
  min-height: 100vh;
  background: ${colors.white};
  display: flex;
`;

export const LoginContent = styled('div')`
  background: ${colors.white};
  width: 40%;
  margin: 20vh auto 0;
  // border: 1px solid ${colors.white_03};
  // box-shadow: 0px 4px 8px rgba(16, 24, 40, 0.1);
  // border-radius: 8px;
  padding: 20px 0;
  position: relative;
  min-height: 590px;
`;

export const LoginInputWrapper = styled.div`
  input[type='text'] {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    background-color: #f1f1f1;
  }
  .validation-error {
    text-align: left;
    margin-left: 5px;
    margin-right: 5px;
    padding-top: 2px;
  }
`;

export const LoginInputWrapperV2 = styled.div`
  input[type='text'] {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    background-color: #fff !important;
  }
  .validation-error {
    text-align: left;
    margin-left: 5px;
    margin-right: 5px;
    padding-top: 2px;
  }
`;

export const LoginLogo = styled(ResponsiveImg)`
  width: 160px;
`;

export const LoginLogoStyle = styled(ResponsiveImg)`
  height: 80px;
`;

export const LoginFooter = styled(Flex)`
  position: absolute;
  bottom: 3px;
  padding: 5px;
  font-size: 12px;
  margin: 0 auto;
  width: 100%;
  justify-content: center;
`;

export const SocialLoginButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
`;

export const GoogleLoginLabel = styled.label`
  button {
    width: 0;
    height: 0;
    display: none !important;
  }
  svg {
    margin: 0;
    background: #6351ed;
  }
`;

export const LinkedInLabel = styled.label`
  button {
    width: 0;
    height: 0;
    display: none !important;
  }
  svg {
    margin: 0;
    background: #6351ed;
  }
`;

export const TwitterLoginLabel = styled.label`
  button {
    width: 0;
    height: 0;
    display: none !important;
  }
  svg {
    margin: 0;
    background: #6351ed;
  }
`;

export const OutlookLabel = styled.label`
  img {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    vertical-align: middle;
    text-align: center;
    color: #ffffff;
    background: #6351ed;
    padding: 4px;
    cursor: pointer;
  }
`;

export const LoginSplash = styled('div')`
  width: 60%;
  background: ${colors.purple_gradient};
  display: table;
  min-height: 100vh;
`;

export const LinkStyle = styled('a')`
  text-decoration: none;
  cursor: pointer;
  transition: 1s;
  color: #816EF8;
  :hover {
    text-decoration: underline;
  }
`;

export const LoginHeader = styled('div')`
  font-weight: 600;
  font-size: 36px;
  color: #FFFFFF;
  margin: 24vh auto 0;
  text-align: center;
`;

export const IconDisplay = styled('div')`
  display: flex;
  justify-content: space-between;
  width: 75%;
  margin: 80px auto 0;
`;

export const IconStyle = styled('img')`
  height: 140px;
  width: 140px;
`;

export const IconName = styled('div')`
  font-weight: 500;
  font-size: 20px;
  text-align: center;
  color: #F6F2FF;
`;
